<template>
	<article ref="scrollBox" style="height:100%;">
		<section><swiper :swiperImgArray="advertList" :swiperWrapClass="swiperClass" :autoPlay="true" style="position:relative;z-index:1;"></swiper></section>
		<section class="shopType">
			<div><img src="../assets/jipiao.png" v-on:click="selectType('airport')" /></div>
			<div><img src="../assets/jiudian.png" v-on:click="selectType('hotel')" /></div>
			<div><img src="../assets/menpiao.png" v-on:click="selectType('ticket')" /></div>
			<div><img src="../assets/menpiao.png" v-on:click="selectType('travel')" /></div>
		</section>
	</article>
</template>

<script>
import Swiper from './child-components/Swiper';
export default {
	name: 'shopQueryIndex',
	data() {
		return {
			advertList: [],
			swiperClass: 'big_banner_wrap'
		};
	},
	components: {
		swiper: Swiper
	},
	mounted() {
		this.getAdvertList();
	},
	activated() {},
	methods: {
		//获取轮播图列表：
		getAdvertList() {
			let that = this;
			this.advertList = [];
			this.advertList.push('https://www.callmefix.net/img/checpticketevent.jpg', 'https://www.callmefix.net/img/pickup.jpg');
		},
		selectType(type) {
			this.$router.push({
				name: 'shopTypePage',
				params: {
					type: type
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import '../style/home.less';
.shopType {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 10% 0 0 0;
}
.shopType div {
	text-align: center;
	width: 45%;
	margin: 0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shopQueryIndex.vue